
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

const PROPERTY_TYPES = ["شقة", "فيلا", "استوديو", "دوبلكس"];
const FURNISHING_OPTIONS = [
  { value: "furnished", label: "مفروش" },
  { value: "unfurnished", label: "غير مفروش" },
  { value: "semi_furnished", label: "مفروش جزئياً" }
];

interface BasicInfoStepProps {
  data: any;
  onChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

const BasicInfoStep = ({ data, onChange, errors }: BasicInfoStepProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-right flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">1</div>
          المعلومات الأساسية
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="title">عنوان العقار *</Label>
          <Input
            id="title"
            value={data.title || ''}
            onChange={(e) => onChange('title', e.target.value)}
            placeholder="أدخل عنوان جذاب للعقار"
            className="text-right"
          />
          {errors?.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="type">نوع العقار *</Label>
            <Select value={data.type || ''} onValueChange={(value) => onChange('type', value)}>
              <SelectTrigger>
                <SelectValue placeholder="اختر النوع" />
              </SelectTrigger>
              <SelectContent>
                {PROPERTY_TYPES.map(type => (
                  <SelectItem key={type} value={type}>{type}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            {errors?.type && <p className="text-red-500 text-sm mt-1">{errors.type}</p>}
          </div>

          <div>
            <Label htmlFor="monthly_price">السعر الشهري (ر.ع) *</Label>
            <Input
              id="monthly_price"
              type="number"
              value={data.monthly_price || ''}
              onChange={(e) => onChange('monthly_price', e.target.value)}
              placeholder="300"
              className="text-right"
            />
            {errors?.monthly_price && <p className="text-red-500 text-sm mt-1">{errors.monthly_price}</p>}
          </div>
        </div>

        <div>
          <Label htmlFor="address">العنوان *</Label>
          <Input
            id="address"
            value={data.address || ''}
            onChange={(e) => onChange('address', e.target.value)}
            placeholder="مثال: مسقط - الخوض"
            className="text-right"
          />
          {errors?.address && <p className="text-red-500 text-sm mt-1">{errors.address}</p>}
        </div>

        <div>
          <Label htmlFor="furnishing_status">حالة الأثاث</Label>
          <Select value={data.furnishing_status || 'unfurnished'} onValueChange={(value) => onChange('furnishing_status', value)}>
            <SelectTrigger>
              <SelectValue placeholder="اختر حالة الأثاث" />
            </SelectTrigger>
            <SelectContent>
              {FURNISHING_OPTIONS.map(option => (
                <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="description">وصف مختصر</Label>
          <Textarea
            id="description"
            value={data.description || ''}
            onChange={(e) => onChange('description', e.target.value)}
            placeholder="وصف مختصر يظهر في بطاقة العرض"
            className="text-right"
            rows={3}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default BasicInfoStep;
